<script>
import { isMobileMixin } from '@src/mixins/isMobileMixin'

export default {
  mixins: [isMobileMixin],
  props: {
    src: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
    },
    hoverEffect: {
      type: Boolean,
    },
    height: {
      type: [Number, null],
      default: null,
    },
    width: {
      type: [Number, null],
      default: null,
    },
  },
  data() {
    return {
      defaultPicture: require('@assets/images/logo-icon.svg'),
      errorLoading: false,
      defaultMobileSize: 32,
      defaultDesktopSize: 48,
    }
  },
  computed: {
    picturePath() {
      if (this.errorLoading) {
        return this.defaultPicture
      }

      return this.src || this.defaultPicture
    },

    getHeight() {
      if (this.height) {
        return this.height
      }

      if (this.isMobile) {
        return 32
      }

      return 48
    },

    getWidth() {
      if (this.width) {
        return this.width
      }

      if (this.isMobile) {
        return 32
      }

      return 48
    },
  },
}
</script>

<template>
  <div
    :style="{
      height: `${getHeight}px`,
      width: `${getWidth}px`,
      'flex-shrink': 0,
    }"
    :class="{
      [$style.profilePictureImgWrapper]: true,
      [$style.active]: active,
      [$style.profilePictureImgHoverEffect]: hoverEffect,
    }">
    <img :src="picturePath" :class="{ [$style.profilePictureImg]: true }" @error="errorLoading = true" />
  </div>
</template>

<style lang="scss" module>
@import '@design';

$profile-picture-size: 48px;
$profile-picture-size-mobile: 32px;

.profilePictureImgWrapper {
  overflow: hidden;
  border-radius: 50%;
}

.profilePictureImg {
  width: 100%;
  height: 100%;
  vertical-align: top;
  transform: scale(1.05);
  object-fit: cover;
}

.profilePictureImgHoverEffect {
  &:hover {
    filter: brightness(90%);
  }
}

.active {
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 1), 0 0 0 4px $primary-blue;
}
</style>
